import React, { useEffect } from "react";
import gpsBanner from "../../../assets/gps/banner.png";
import AOS from "aos";
import "aos/dist/aos.css";
const Banner = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);
  return (
    <div>
      <div className="relative">
        <img src={gpsBanner} className="bg-cover w-full" data-aos="zoom-in" />
        <h1
          className="absolute inset-0 flex items-center justify-center text-black xl:text-5xl md:text-3xl text-xl font-bold tracking-wide"
          data-aos="fade-left"
        >
          Gps Services
        </h1>
      </div>
    </div>
  );
};

export default Banner;
